module.exports = __webpack_public_path__ + "img/位图备份_16.65a5825c.jpg";